import { useState, useCallback } from 'react';
import {
    CHIPS_CLASS_TYPE_MAPPING,
    EV_FILTERS_TYPES,
    openGoogleMaps,
    getEffectiveDecayDays,
    getDecayBreakdown,
    getEvBucket,
} from './helper';
import {
    Box,
    Button,
    Divider,
    Grid,
    IconButton,
    Paper,
    Popover,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tooltip,
    Typography,
    withStyles,
} from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import useEVStyles from './useEVStyles';
import clsx from 'clsx';
import BatteryIcon from './components/BatteryIcon';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import NearMeIcon from '@material-ui/icons/NearMe';
import CustomDropdown from '../../components/Dropdown';
import CloseIcon from '@material-ui/icons/Close';
import { getMaskedNumber } from '../../utils/helper';
// Define the hook's return type
interface useEVTableReturn {
    getCardFilterView: Function;
    StyledTableCell: any;
    StyledTableHeadCell: any;
    StyledTableRow: any;
    getColumnComponentValue: Function;
    handleRowClick: Function;
    handleConfirmYes: Function;
    handleConfirmNo: Function;
}
export const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        padding: '8px 8px',
        borderTop: '1px solid #EBEDF8',
        borderBottom: '1px solid #EBEDF8',
        '&:first-child': {
            paddingLeft: '16px',
            borderTopLeftRadius: '4px',
            borderBottomLeftRadius: '4px',
            borderLeft: '1px solid #EBEDF8',
        },
        '&:last-child': {
            paddingRight: '16px',
            borderTopRightRadius: '4px',
            borderBottomRightRadius: '4px',
            borderRight: '1px solid #EBEDF8',
        },
    },
}))(TableCell);
export const StyledTableHeadCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.white,
        color: '#525050',
        fontWeight: 600,
        fontSize: 13,
        letterSpacing: '0.3px',
        textTransform: 'capitalize',
        whiteSpace: 'nowrap',
        padding: '12px 16px',
        borderBottom: 'none',
        //textAlign: 'center',
        minWidth: '110px',
    },
    body: {
        fontSize: 16,
    },
}))(TableCell);

export const StyledTableRow: any = withStyles((theme) => ({
    root: {
        marginBottom: '8px',
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.common.white,
        },
        border: '1px solid #EBEDF8',
        borderRadius: '4px',
        backgroundColor: '#F8F9FA',
        cursor: 'pointer',
    },
}))(TableRow);
const IOSSwitch = withStyles((theme) => ({
    root: {
        width: 32,
        height: 18,
        padding: 0,
        margin: theme.spacing(1),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 16,
        height: 16,
    },
    track: {
        borderRadius: 18 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }: any) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

const useEVTable = ({
    filtered,
    history,
    evListData,
    baselineCardTotals,
    activeFilterCard,
    setActiveFilterCard,
    onPressMobilize,
    onPressEnergyControl,
    confirmModalOpen,
    setConfirmModalOpen,
    confirmData,
    setConfirmData,
    evListingPayload,
    pagination,
    onSendLocation,
    onBlockUnblock,
}: any): useEVTableReturn => {
    console.log('thhhhhh', evListData);
    const classes: any = useEVStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState<any>(null);


    const handleTaggedUsedGoalClick = (event: any, index: number) => {
        event?.stopPropagation();
        event?.preventDefault();
        setAnchorEl(null);
        setSelectedIndex(null);
        setSelectedIndex(index);
        setAnchorEl(event.currentTarget);
    };

    const handleTaggedUsedGoalClose = (e: any) => {
        e?.stopPropagation();
        e?.preventDefault();
        setSelectedIndex(null);
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const taggedUsedGoalId = open
        ? 'simple-popover-taggedUsedGoalId'
        : undefined;

    // Memoized increment function
    const increment = useCallback(() => {}, []);

    // Memoized decrement function
    const decrement = useCallback(() => {}, []);

    const getFormattedValue = (type: any) => {
        const lineItems: any[] = evListData?.evLineItemList ?? [];
        const criticalCount = lineItems.filter(
            (r: any) => getEvBucket(r) === 'CRITICAL',
        ).length;
        const blockedCount = lineItems.filter((r: any) => {
            const mobilityStatusRaw =
                r?.mobilityStatus ?? r?.evTelematicInfo?.mobilityStatus;
            return (
                !!r?.blockedByCm ||
                r?.blockStatus === 'BLOCKED' ||
                mobilityStatusRaw === false
            );
        }).length;
        switch (type) {
            case 'TAGGED_ALL':
                return (
                    baselineCardTotals?.totalCount ??
                    evListData?.totalEv ??
                    evListData?.totalCount ??
                    0
                );
            case 'IN_CRITICAL':
                return baselineCardTotals?.criticalCount ?? criticalCount;
            case 'CURRENTLY_BLOCKED':
                return (
                    baselineCardTotals?.blockedCount ??
                    evListData?.blockedEv ??
                    blockedCount
                );
            case 'PARTIALLY_BLOCKED':
                return (
                    baselineCardTotals?.partiallyBlockedCount ??
                    evListData?.partiallyBlockedEv ??
                    0
                );
            case EV_FILTERS_TYPES.TOTAL:
                return (
                    <>
                        <Typography
                            className={classes.filterValue}
                            component={'span'}
                        >
                            {`${evListData?.taggedEv ?? 0}`}
                            <Typography
                                className={classes.filterByValue}
                                component={'span'}
                            >
                                {` / ${evListData?.totalEv ?? 0}`}
                            </Typography>
                        </Typography>
                    </>
                );
            case EV_FILTERS_TYPES.ACTIVE:
                return evListData?.activeEv ?? 0;
            case EV_FILTERS_TYPES.GPS:
                return evListData?.evGpsDetails?.enabledCount ?? 0;
            case EV_FILTERS_TYPES.GPS_OFF:
                return evListData?.evGpsDetails?.offCount ?? 0;
            case EV_FILTERS_TYPES.GPS_ON:
                return evListData?.evGpsDetails?.onCount ?? 0;
            case EV_FILTERS_TYPES.GPS_R_OFF:
                return evListData?.evGpsDetails?.remoteOffCount ?? 0;
            default:
                return '0';
        }
    };

    // Expose state and functions
    const getCardFilterView = (filter: any, totalCount: number) => {
        let content: any = <></>;
        switch (filter?.type) {
            default:
                content = (
                    <Box
                        display={'flex'}
                        flexDirection={'row'}
                        alignItems={'center'}
                    >
                        <Box minWidth={'130px'}>
                            <Typography
                                className={classes.filterTitle}
                                component={'p'}
                            >
                                {filter?.name}
                            </Typography>
                            <Typography
                                className={classes.filterValue}
                                component={'p'}
                                style={
                                    filter?.accent === 'critical'
                                        ? { color: '#f44336' }
                                        : undefined
                                }
                            >
                                {getFormattedValue(filter?.type)}
                            </Typography>
                            {!!filter?.subText && (
                                <Typography
                                    component={'p'}
                                    style={{
                                        fontSize: 12,
                                        color: '#515f6d',
                                        marginTop: 4,
                                    }}
                                >
                                    {filter?.subText}
                                </Typography>
                            )}
                        </Box>
                        {!!filter?.subFilters?.length && (
                            <Box
                                ml={2}
                                display={'flex'}
                                flexDirection={'row'}
                                alignItems={'center'}
                                width={'100%'}
                            >
                                <Grid container spacing={2}>
                                    {filter?.subFilters?.map(
                                        (subFilter: any, index: number) => {
                                            let isLast =
                                                index ===
                                                filter?.subFilters?.length - 1;
                                            return (
                                                <Grid
                                                    item
                                                    xs
                                                    key={`${subFilter?.type}`}
                                                >
                                                    <Box
                                                        pl={3}
                                                        pr={3}
                                                        borderLeft={
                                                            '1px solid #EBEDF8'
                                                        }
                                                    >
                                                        <Typography
                                                            className={
                                                                classes.filterTitle
                                                            }
                                                            component={'p'}
                                                        >
                                                            {subFilter?.name}
                                                        </Typography>
                                                        <Typography
                                                            className={
                                                                classes.filterSubValue
                                                            }
                                                            component={'p'}
                                                        >
                                                            {getFormattedValue(
                                                                subFilter?.type,
                                                            )}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            );
                                        },
                                    )}
                                </Grid>
                            </Box>
                        )}
                    </Box>
                );
                break;
        }
        return (
            <Grid item xs={filter?.xs ?? true} key={`${filter?.type}`}>
                <Paper
                    className={classes.filterCard}
                    elevation={0}
                    style={
                        filter?.filterValue == activeFilterCard
                            ? {
                                  backgroundColor: '#d1d8ff',
                              }
                            : {}
                    }
                    onClick={() => {
                        setActiveFilterCard(filter?.filterValue);
                    }}
                >
                    {content}
                </Paper>
            </Grid>
        );
    };

    const actionDropDown = (val: any) => {
        let options: any = [];
        const mapView = {
            item: 'Map View',
            onSuccess: (e: any) => {
                e?.stopPropagation();
                e?.preventDefault();
                if (!!val?.taggedRiderDetails?.contactNumber) {
                    handleSingleEVPage(val, 1);
                }
            },
            disabled: !val?.taggedRiderDetails?.contactNumber,
        };
        const taggingHistory = {
            item: 'Tagging History',
            onSuccess: () => {
                handleSingleEVPage(val, 0);
            },
            disabled: false,
        };
        options = [mapView, taggingHistory];
        return (
            <CustomDropdown
                title={'Options'}
                options={options}
                optionStyles={null}
                expandMoreButtonStyles={null}
                styledMenuItemStyles={classes.menu}
                buttonProps={null}
                buttonStyles={null}
            />
        );
    };
    const getColorBasedOnValue = (value: string): any => {
        console.log('trhddd', value);
        // Extract the number from the string
        const numberMatch = value?.match(/D-(\d+)/);
        if (!numberMatch) return value; // Default color if no match
        console.log('trhddd', numberMatch);

        const number = parseInt(numberMatch[1]);

        // Determine color based on the extracted number
        if (number <= 3) {
            return 'D_PENDING';
        } else if (number >= 4) {
            return 'D_REJECT';
        }
    };

    const getColumnComponentValue = (
        row: any,
        column: any,
        handleAction: any,
        index: number,
    ) => {
        let compValue: any = row?.[column?.valueKey] ?? '-/-';
        const odd = index % 2 == 0 ? false : true;

        const orderStatus: any = row?.orderStatus
            ?.toUpperCase()
            ?.replace(' ', '_')
            ?.trim();
        const evStatus: any = row?.evStatus
            ?.toUpperCase()
            ?.replace(' ', '_')
            ?.replace('-', '_')
            ?.trim()
            ?.replace(/[\s-]+/g, '_');

        let chipEVClass: any =
            classes?.[`${CHIPS_CLASS_TYPE_MAPPING?.[evStatus]}`];
        let chipOrderClass: any =
            classes?.[
                `${
                    CHIPS_CLASS_TYPE_MAPPING?.[
                        getColorBasedOnValue(orderStatus)
                    ]
                }`
            ];
        switch (column?.mappingKey) {
            case 'evDetails':
                compValue = (
                    <Box
                        display={'flex'}
                        flexDirection={'row'}
                        alignItems={'center'}
                        justifyContent={'flex-start'}
                    >
                        <Box>
                            <Box
                                display={'flex'}
                                flexDirection={'row'}
                                mb={0.5}
                            >
                                <Typography className={classes.evNumber}>
                                    {row?.evNumber ?? '-'}
                                </Typography>
                                {row?.iotPartnerRemoteControlEnabled && (
                                    <Typography
                                        className={clsx(
                                            classes.vehicleIgnitionStatus,
                                            classes?.[
                                                `${
                                                    !!row?.evTelematicInfo
                                                        ?.mobiliStatus
                                                        ? 'ROFF'
                                                        : !!row?.evTelematicInfo
                                                              ?.vehicleIgnitionStatus
                                                        ? 'ON'
                                                        : 'OFF'
                                                }`
                                            ],
                                        )}
                                    >
                                        {row?.evTelematicInfo
                                            ?.vehicleIgnitionStatus
                                            ? `(${
                                                  !!row?.evTelematicInfo
                                                      ?.mobiliStatus
                                                      ? 'Roff'
                                                      : !!row?.evTelematicInfo
                                                            ?.vehicleIgnitionStatus
                                                      ? 'On'
                                                      : 'Off'
                                              })`
                                            : '(Off)'}
                                    </Typography>
                                )}
                            </Box>
                            <Box display={'flex'} flexDirection={'row'}>
                                <Typography className={classes.evVendor}>
                                    {row?.vendor ?? '-'}
                                </Typography>
                                {!!row?.evTelematicInfo?.vehicleBattery && (
                                    <>
                                        <BatteryIcon
                                            percentage={
                                                row?.evTelematicInfo
                                                    ?.vehicleBattery
                                            }
                                            fontSize={17}
                                        />
                                        <Typography
                                            className={classes.evVendor}
                                            component={'span'}
                                        >
                                            <Typography component={'span'}>
                                                {`${row?.evTelematicInfo?.vehicleBattery}% battery`}
                                            </Typography>
                                        </Typography>
                                    </>
                                )}
                            </Box>
                        </Box>
                        {!!row?.iotPartnerTelematicsEnabled &&
                            !!row?.evTelematicInfo?.latitude &&
                            !!row?.evTelematicInfo?.longitude && (
                                <Box ml={3} display={'flex'} alignItems={'center'}>
                                    <IconButton
                                        color="primary"
                                        aria-label="map direction"
                                        component="span"
                                        className={classes.directionCTA}
                                        onClick={(e: any) => {
                                            e?.stopPropagation();
                                            e?.preventDefault();
                                            openGoogleMaps(
                                                row?.evTelematicInfo?.latitude,
                                                row?.evTelematicInfo?.longitude,
                                            );
                                        }}
                                    >
                                        <NearMeIcon className={classes.directionIcon} />
                                    </IconButton>
                                </Box>
                            )}
                    </Box>
                );
                break;
            case 'riderDetails':
                compValue = (
                    <Box pl={3}>
                        <Typography className={classes.tableValue}>
                            {row?.taggedRiderDetails?.name ?? '-'}
                        </Typography>
                        <Typography className={classes.tableSubValue}>
                            {getMaskedNumber(
                                row?.taggedRiderDetails?.contactNumber,
                            ) ?? '-'}
                        </Typography>
                    </Box>
                );
                break;
            case 'iotControl':
                compValue = (
                    <Box display={'flex'} flexDirection={'column'} alignItems={'flex-start'}>
                        <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
                            <Tooltip title={row?.iotPartnerRemoteControlEnabled ? '' : 'IoT remote control not enabled'}>
                                <span>
                                    <IOSSwitch
                                        checked={!row?.evTelematicInfo?.mobiliStatus}
                                        disabled={!row?.iotPartnerRemoteControlEnabled}
                                        onClick={(e: any) => { e?.stopPropagation(); e?.preventDefault(); }}
                                        onChange={(e: any) => {
                                            e?.stopPropagation(); e?.preventDefault();
                                            setConfirmData({
                                                ...row,
                                                controlType: 'iot',
                                                confirmText: `remotely switch ${row?.evTelematicInfo?.mobiliStatus ? 'ON' : 'OFF'} the EV (IoT)`,
                                            });
                                            setConfirmModalOpen(true);
                                        }}
                                        name="iotSwitch"
                                        className={classes.remoteSwitch}
                                    />
                                </span>
                            </Tooltip>
                        </Box>
                        <Typography className={classes.tableSubValue}>
                            {row?.iotPartnerName ?? '-'}
                        </Typography>
                    </Box>
                );
                break;
            case 'energyControl':
                compValue = (
                    <Box display={'flex'} flexDirection={'column'} alignItems={'flex-start'}>
                        <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
                            <Tooltip title={row?.energyPartnerRemoteControlEnabled ? '' : 'Energy partner not configured or remote disabled'}>
                                <span>
                                    <IOSSwitch
                                        checked={!!row?.evTelematicInfo?.energyPartnerIgnitionStatus}
                                        disabled={!row?.energyPartnerRemoteControlEnabled}
                                        onClick={(e: any) => { e?.stopPropagation(); e?.preventDefault(); }}
                                        onChange={(e: any) => {
                                            e?.stopPropagation(); e?.preventDefault();
                                            setConfirmData({
                                                ...row,
                                                controlType: 'energy',
                                                confirmText: `remotely switch ${row?.evTelematicInfo?.energyPartnerIgnitionStatus ? 'OFF' : 'ON'} the EV (Energy Partner)`,
                                            });
                                            setConfirmModalOpen(true);
                                        }}
                                        name="energySwitch"
                                        className={classes.remoteSwitch}
                                    />
                                </span>
                            </Tooltip>
                        </Box>
                        <Typography className={classes.tableSubValue}>
                            {row?.energyPartnerName ?? '-'}
                        </Typography>
                    </Box>
                );
                break;
            case 'taggedUsedGoal':
                compValue = (
                    <div>
                        <Box
                            display={'flex'}
                            flexDirection={'row'}
                            alignItems={'center'}
                            justifyContent={'space-between'}
                            className={classes.taggedUsedGoal}
                            onClick={(e: any) => {
                                if (
                                    !!row?.evProductivity?.taggingDetails ||
                                    !!row?.evProductivity?.usagesDetails ||
                                    !!row?.evProductivity?.goalDetails
                                ) {
                                    handleTaggedUsedGoalClick(e, index);
                                }
                            }}
                            //bgcolor={!!odd ? '#fff' : '#EBEDF8'}
                        >
                            <Typography
                                component={'span'}
                                className={
                                    row?.evProductivity?.taggingDetails
                                        ?.taggedPercentage > 25
                                        ? classes.tableValue
                                        : classes.tableValueInRed
                                }
                            >
                                {row?.evProductivity?.taggingDetails
                                    ?.taggedPercentage != null
                                    ? `${row?.evProductivity?.taggingDetails?.taggedPercentage}%`
                                    : '-'}
                            </Typography>
                            <Typography
                                component={'span'}
                                className={classes.tableValue}
                                style={{
                                    padding: '0 6px',
                                }}
                            >
                                |
                            </Typography>
                            <Typography
                                component={'span'}
                                className={
                                    row?.evProductivity?.usagesDetails
                                        ?.usedPercentage > 25
                                        ? classes.tableValue
                                        : classes.tableValueInRed
                                }
                            >
                                {row?.evProductivity?.usagesDetails
                                    ?.usedPercentage != null
                                    ? `${row?.evProductivity?.usagesDetails?.usedPercentage}%`
                                    : '-'}
                            </Typography>
                            <Typography
                                component={'span'}
                                className={classes.tableValue}
                                style={{
                                    padding: '0 6px',
                                }}
                            >
                                |
                            </Typography>
                            <Typography
                                component={'span'}
                                className={
                                    row?.evProductivity?.goalDetails
                                        ?.goalPercentage > 25
                                        ? classes.tableValue
                                        : classes.tableValueInRed
                                }
                            >
                                {row?.evProductivity?.goalDetails
                                    ?.goalPercentage != null
                                    ? `${row?.evProductivity?.goalDetails?.goalPercentage}%`
                                    : '-'}
                            </Typography>
                        </Box>
                        {anchorEl && index == selectedIndex && (
                            <Popover
                                id={taggedUsedGoalId}
                                open={anchorEl && index == selectedIndex}
                                anchorEl={anchorEl}
                                onClose={handleTaggedUsedGoalClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                PaperProps={{
                                    square: true,
                                    classes: {
                                        root: classes.popOver,
                                    },
                                    onClick: (e) => {
                                        e?.stopPropagation();
                                        e?.preventDefault();
                                    },
                                }}
                            >
                                <Box
                                    display={'flex'}
                                    flexDirection={'row'}
                                    //alignItems={'center'}
                                    justifyContent={'space-between'}
                                    onClick={(e) => {
                                        e?.stopPropagation();
                                        e?.preventDefault();
                                    }}
                                >
                                    <Box flex={1}>
                                        <Typography
                                            className={classes.tableValue}
                                        >
                                            EV Performance summary
                                        </Typography>
                                        <Typography
                                            className={classes.tableSubValue}
                                        >
                                            {row?.evNumber ?? '-'}
                                        </Typography>
                                    </Box>
                                    <IconButton
                                        aria-label="close popover"
                                        onClick={handleTaggedUsedGoalClose}
                                        className={classes.closeCTA}
                                    >
                                        <CloseIcon
                                            className={classes.closeIcon}
                                        />
                                    </IconButton>
                                </Box>
                                <Box
                                    style={{
                                        margin: '16px 0',
                                        height: 1,
                                        backgroundColor: '#EAEDF3',
                                    }}
                                />
                                <Box flexGrow={1}>
                                    <Grid container spacing={1}>
                                        <Grid item xs>
                                            <Paper
                                                className={classes.permCard}
                                                elevation={0}
                                            >
                                                <Typography
                                                    className={
                                                        classes.permTitle
                                                    }
                                                    component={'p'}
                                                >
                                                    {'Tagged'}
                                                </Typography>
                                                <Typography
                                                    className={
                                                        classes.permValue
                                                    }
                                                    component={'p'}
                                                >
                                                    {`${
                                                        row?.evProductivity
                                                            ?.taggingDetails
                                                            ?.taggedDays ?? '-'
                                                    } / ${
                                                        (row?.evProductivity
                                                            ?.taggingDetails
                                                            ?.totalNoOfDays ??
                                                            '-') + ' days'
                                                    }`}
                                                </Typography>
                                                {!!row?.evProductivity
                                                    ?.taggingDetails
                                                    ?.taggedPercentage && (
                                                    <Typography
                                                        component={'p'}
                                                        className={
                                                            row?.evProductivity
                                                                ?.taggingDetails
                                                                ?.taggedPercentage >
                                                            25
                                                                ? classes.permSubValue
                                                                : classes.tableSubValueRed
                                                        }
                                                    >
                                                        {row?.evProductivity
                                                            ?.taggingDetails
                                                            ?.taggedPercentage
                                                            ? `${
                                                                  row
                                                                      ?.evProductivity
                                                                      ?.taggingDetails
                                                                      ?.taggedPercentage ??
                                                                  0
                                                              }%`
                                                            : '-'}
                                                    </Typography>
                                                )}
                                            </Paper>
                                        </Grid>
                                        <Grid item xs>
                                            <Paper
                                                className={classes.permCard}
                                                elevation={0}
                                            >
                                                <Typography
                                                    className={
                                                        classes.permTitle
                                                    }
                                                    component={'p'}
                                                >
                                                    {'Usage'}
                                                </Typography>
                                                <Typography
                                                    className={
                                                        classes.permValue
                                                    }
                                                    component={'p'}
                                                >
                                                    {`${
                                                        row?.evProductivity
                                                            ?.usagesDetails
                                                            ?.usedDays ?? '-'
                                                    } / ${
                                                        (row?.evProductivity
                                                            ?.usagesDetails
                                                            ?.totalNoOfDays ??
                                                            '-') + ' days'
                                                    }`}
                                                </Typography>
                                                {!!row?.evProductivity
                                                    ?.usagesDetails
                                                    ?.usedPercentage && (
                                                    <Typography
                                                        component={'p'}
                                                        className={
                                                            row?.evProductivity
                                                                ?.usagesDetails
                                                                ?.usedPercentage >
                                                            25
                                                                ? classes.permSubValue
                                                                : classes.tableSubValueRed
                                                        }
                                                    >
                                                        {row?.evProductivity
                                                            ?.usagesDetails
                                                            ?.usedPercentage
                                                            ? `${
                                                                  row
                                                                      ?.evProductivity
                                                                      ?.usagesDetails
                                                                      ?.usedPercentage ??
                                                                  0
                                                              }%`
                                                            : '-'}
                                                    </Typography>
                                                )}
                                            </Paper>
                                        </Grid>
                                        <Grid item xs>
                                            <Paper
                                                className={clsx(
                                                    classes.permCard,
                                                    classes.permCardRed,
                                                )}
                                                elevation={0}
                                            >
                                                <Typography
                                                    className={
                                                        classes.permTitle
                                                    }
                                                    component={'p'}
                                                >
                                                    {'Order KM Goal achieved'}
                                                </Typography>
                                                <Typography
                                                    className={
                                                        classes.permValue
                                                    }
                                                    component={'p'}
                                                >
                                                    {`${
                                                        row?.evProductivity
                                                            ?.goalDetails
                                                            ?.goalAchievedDays ??
                                                        '-'
                                                    } / ${
                                                        (row?.evProductivity
                                                            ?.goalDetails
                                                            ?.totalNoOfDays ??
                                                            '-') + ' days'
                                                    }`}
                                                </Typography>
                                                {!!row?.evProductivity
                                                    ?.goalDetails
                                                    ?.goalPercentage && (
                                                    <Typography
                                                        component={'p'}
                                                        className={
                                                            row?.evProductivity
                                                                ?.goalDetails
                                                                ?.goalPercentage >
                                                            25
                                                                ? classes.permSubValue
                                                                : classes.tableSubValueRed
                                                        }
                                                    >
                                                        {row?.evProductivity
                                                            ?.goalDetails
                                                            ?.goalPercentage
                                                            ? `${
                                                                  row
                                                                      ?.evProductivity
                                                                      ?.goalDetails
                                                                      ?.goalPercentage ??
                                                                  0
                                                              }%`
                                                            : '-'}
                                                    </Typography>
                                                )}
                                            </Paper>
                                        </Grid>
                                        <Grid item xs>
                                            <Paper
                                                className={clsx(
                                                    classes.permCard,
                                                    classes.permCardRed,
                                                )}
                                                elevation={0}
                                            >
                                                <Typography
                                                    className={
                                                        classes.permTitle
                                                    }
                                                    component={'p'}
                                                >
                                                    {'Moonlighting %'}
                                                </Typography>
                                                <Typography
                                                    className={
                                                        classes.permValue
                                                    }
                                                    component={'p'}
                                                >
                                                    {`${
                                                        row?.evProductivity
                                                            ?.moonLightingDetails
                                                            ?.totalOrderKm ??
                                                        '-'
                                                    } Km / ${
                                                        row?.evProductivity
                                                            ?.moonLightingDetails
                                                            ?.totalEvKm ?? '-'
                                                    } Km (Order / EV)`}
                                                </Typography>
                                                {!!row?.evProductivity
                                                    ?.moonLightingDetails
                                                    ?.moonlightingPercentage && (
                                                    <Typography
                                                        component={'p'}
                                                        className={
                                                            row?.evProductivity
                                                                ?.moonLightingDetails
                                                                ?.moonlightingPercentage >
                                                            25
                                                                ? classes.permSubValue
                                                                : classes.tableSubValueRed
                                                        }
                                                    >
                                                        {row?.evProductivity
                                                            ?.moonLightingDetails
                                                            ?.moonlightingPercentage
                                                            ? `${
                                                                  row
                                                                      ?.evProductivity
                                                                      ?.moonLightingDetails
                                                                      ?.moonlightingPercentage ??
                                                                  0
                                                              }%`
                                                            : '-'}
                                                    </Typography>
                                                )}
                                            </Paper>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Popover>
                        )}
                    </div>
                );
                break;
            case 'city':
                compValue = (
                    <Box>
                        <Typography className={classes.tableValue}>
                            {row?.city ?? '-'}
                        </Typography>
                    </Box>
                );
                break;
            case 'lob':
                compValue = (
                    <Box>
                        <Typography className={classes.tableValue}>
                            {row?.taggedProject ?? '-'}
                        </Typography>
                    </Box>
                );
                break;
            case 'evStatus': {
                const bucket: string = row?.bucket ?? '';
                const bucketU = bucket.toUpperCase();
                const bucketColors: any = {
                    CRITICAL: { bg: '#fee2e2', fg: '#b91c1c' },
                    HIGH: { bg: '#ffedd5', fg: '#c2410c' },
                    MEDIUM: { bg: '#fef3c7', fg: '#92400e' },
                    WATCH: { bg: '#dbeafe', fg: '#1e40af' },
                    HEALTHY: { bg: '#dcfce7', fg: '#166534' },
                };
                const bc = bucketColors[bucketU] || { bg: '#F3F6FF', fg: '#525050' };
                const wallet: number = Number(row?.walletBalance ?? 0);
                const decay: number = getEffectiveDecayDays(row) ?? 0;
                const breaches: string[] = [];
                if (wallet < 0) breaches.push('Wallet');
                if (decay >= 3) breaches.push('Decay');
                compValue = (
                    <Box display={'flex'} flexDirection={'column'} style={{ gap: 6 }}>
                        {bucket ? (
                            <Box
                                style={{
                                    alignSelf: 'flex-start',
                                    background: bc.bg,
                                    color: bc.fg,
                                    borderRadius: 999,
                                    padding: '2px 10px',
                                    fontSize: 11,
                                    fontWeight: 700,
                                    letterSpacing: 0.5,
                                    textTransform: 'uppercase',
                                }}
                            >
                                {bucket}
                            </Box>
                        ) : null}
                        {breaches.length > 0 && (
                            <Box display={'flex'} flexWrap={'wrap'} style={{ gap: 4 }}>
                                {breaches.map((b) => (
                                    <Box
                                        key={b}
                                        style={{
                                            background: '#fee2e2',
                                            color: '#b91c1c',
                                            borderRadius: 999,
                                            padding: '2px 8px',
                                            fontSize: 11,
                                            fontWeight: 600,
                                        }}
                                    >
                                        {b}
                                    </Box>
                                ))}
                            </Box>
                        )}
                        {row?.isBlocked && (
                            <Box
                                style={{
                                    alignSelf: 'flex-start',
                                    background: '#F3F6FF',
                                    color: '#525050',
                                    borderRadius: 999,
                                    padding: '2px 8px',
                                    fontSize: 10,
                                    fontWeight: 700,
                                    letterSpacing: 0.5,
                                    textTransform: 'uppercase',
                                }}
                            >
                                Blocked by CM
                            </Box>
                        )}
                    </Box>
                );
                break;
            }
            case 'wallet': {
                const wallet: number = Number(row?.walletBalance ?? 0);
                const negative = wallet < 0;
                compValue = (
                    <Box
                        style={{
                            display: 'inline-block',
                            background: negative ? '#fee2e2' : '#dcfce7',
                            color: negative ? '#b91c1c' : '#166534',
                            borderRadius: 6,
                            padding: '4px 10px',
                            fontSize: 12,
                            fontWeight: 600,
                        }}
                    >
                        {`${negative ? '-' : ''}₹${Math.abs(wallet)}`}
                    </Box>
                );
                break;
            }
            case 'decay': {
                const effective = getEffectiveDecayDays(row);
                const decay: number = effective ?? 0;
                const tone = decay >= 5 ? { bg: '#fee2e2', fg: '#b91c1c' } : { bg: '#fef3c7', fg: '#92400e' };
                const bd = getDecayBreakdown(row);
                const fmt = (v: any) => (v === null || v === undefined ? '—' : `${v}d`);
                compValue = (
                    <Tooltip
                        title={
                            <Box style={{ fontSize: 11, lineHeight: 1.5 }}>
                                <div>LOD: {fmt(bd.LOD)}</div>
                                <div>Staff/Client: {fmt(bd.StaffClient)}</div>
                                <div>HOA: {fmt(bd.HOA)}</div>
                            </Box>
                        }
                    >
                        <Box
                            style={{
                                display: 'inline-block',
                                background: tone.bg,
                                color: tone.fg,
                                borderRadius: 6,
                                padding: '4px 10px',
                                fontSize: 12,
                                fontWeight: 600,
                                cursor: 'help',
                            }}
                        >
                            {effective === null ? '-' : `${decay}d`}
                        </Box>
                    </Tooltip>
                );
                break;
            }
            case 'action':
                compValue = (
                    <Box>
                        <Typography className={classes.tableValue}>
                            {actionDropDown(row)}
                        </Typography>
                    </Box>
                );
                break;
            case 'eyeDetails':
                compValue = (
                    <IconButton
                        size="small"
                        onClick={(e: any) => {
                            e?.stopPropagation();
                            e?.preventDefault();
                            handleSingleEVPage(row, 2);
                        }}
                    >
                        <VisibilityIcon fontSize="small" style={{ color: '#4B6EFB' }} />
                    </IconButton>
                );
                break;

            case 'riderMobile': {
                const name = row?.taggedRiderDetails?.name ?? row?.riderName ?? '-';
                const mobile =
                    row?.taggedRiderDetails?.contactNumber ??
                    row?.riderContactNumber ??
                    '-';
                compValue = (
                    <Box>
                        <Typography
                            component={'p'}
                            style={{
                                fontSize: 14,
                                fontWeight: 700,
                                color: '#14112D',
                            }}
                        >
                            {name}
                        </Typography>
                        <Typography
                            component={'p'}
                            style={{
                                fontSize: 12,
                                color: '#515f6d',
                                marginTop: 2,
                            }}
                        >
                            {mobile}
                        </Typography>
                    </Box>
                );
                break;
            }
            case 'bucketBreach': {
                const mobilityStatusRaw =
                    row?.mobilityStatus ??
                    row?.evTelematicInfo?.mobilityStatus;
                const isBlocked = mobilityStatusRaw === false;
                const bucket = (getEvBucket(row) || '').toString();
                const bucketStyle: any = {
                    CRITICAL: {
                        bg: 'rgba(244, 67, 54, 0.16)',
                        fg: '#f44336',
                    },
                    HIGH: {
                        bg: 'rgba(255, 152, 0, 0.16)',
                        fg: '#ff9800',
                    },
                    MEDIUM: {
                        bg: 'rgba(255, 193, 7, 0.16)',
                        fg: '#cc8a00',
                    },
                    WATCH: {
                        bg: 'rgba(63, 81, 181, 0.16)',
                        fg: '#3f51b5',
                    },
                    HEALTHY: {
                        bg: 'rgba(76, 175, 80, 0.16)',
                        fg: '#4caf50',
                    },
                };
                const style = bucketStyle[bucket] ?? {
                    bg: '#F4F4F4',
                    fg: '#686868',
                };
                const apiBreaches: string[] = Array.isArray(row?.breaches)
                    ? row.breaches
                    : [];
                const walletVal = row?.walletBalance ?? row?.wallet ?? null;
                const decayVal = getEffectiveDecayDays(row);
                const moonlightVal =
                    row?.moonlightPercentage ??
                    row?.evProductivity?.moonlightingDetails
                        ?.moonlightingPercentage ??
                    null;
                const toNum = (v: any) => {
                    if (v === null || v === undefined || v === '') return null;
                    const n = typeof v === 'number' ? v : Number(v);
                    return Number.isFinite(n) ? n : null;
                };
                const walletNum = toNum(walletVal);
                const decayNum = toNum(decayVal);
                const moonlightNum = toNum(moonlightVal);
                const derivedBreaches: string[] = [];
                if (walletNum !== null && walletNum <= 400)
                    derivedBreaches.push('Wallet');
                if (decayNum !== null && decayNum >= 3)
                    derivedBreaches.push('Decay');
                if (moonlightNum !== null && moonlightNum > 20)
                    derivedBreaches.push('Moonlight');
                const breaches: string[] = Array.from(
                    new Set([...apiBreaches, ...derivedBreaches]),
                );
                const breachPill = (label: string) => (
                    <Box
                        key={label}
                        style={{
                            display: 'inline-block',
                            padding: '2px 10px',
                            borderRadius: 999,
                            background: 'rgba(244, 67, 54, 0.10)',
                            color: '#f44336',
                            fontSize: 11,
                            fontWeight: 600,
                            marginRight: 6,
                            marginTop: 6,
                        }}
                    >
                        {label}
                    </Box>
                );
                compValue = (
                    <Box>
                        {!!bucket && (
                            <Box
                                style={{
                                    display: 'inline-block',
                                    padding: '3px 12px',
                                    borderRadius: 999,
                                    background: style.bg,
                                    color: style.fg,
                                    fontSize: 11,
                                    fontWeight: 700,
                                    letterSpacing: 0.5,
                                }}
                            >
                                {bucket}
                            </Box>
                        )}
                        <Box>
                            {breaches.map((b: string) => breachPill(b))}
                        </Box>
                        {isBlocked && (
                            <Box mt={1}>
                                <Box
                                    style={{
                                        display: 'inline-block',
                                        padding: '4px 14px',
                                        borderRadius: 999,
                                        background: '#FFFFFF',
                                        color: '#1F2A44',
                                        border: '1px solid #C9CFDB',
                                        fontSize: 11,
                                        fontWeight: 700,
                                        letterSpacing: 0.6,
                                    }}
                                >
                                    BLOCKED
                                </Box>
                            </Box>
                        )}
                        {!isBlocked && !!row?.blockedByCm && (
                            <Box mt={1}>
                                <Box
                                    style={{
                                        display: 'inline-block',
                                        padding: '2px 10px',
                                        borderRadius: 999,
                                        background: '#F4F4F4',
                                        color: '#686868',
                                        fontSize: 10,
                                        fontWeight: 700,
                                        letterSpacing: 0.5,
                                    }}
                                >
                                    BLOCKED BY CM
                                </Box>
                            </Box>
                        )}
                    </Box>
                );
                break;
            }
            case 'wallet': {
                const val =
                    row?.walletBalance ?? row?.wallet ?? null;
                const isNegative = typeof val === 'number' && val < 0;
                const isPositive = typeof val === 'number' && val > 0;
                const bg = isNegative
                    ? 'rgba(244, 67, 54, 0.16)'
                    : isPositive
                    ? 'rgba(76, 175, 80, 0.16)'
                    : 'rgba(255, 152, 0, 0.16)';
                const fg = isNegative
                    ? '#f44336'
                    : isPositive
                    ? '#4caf50'
                    : '#ff9800';
                compValue =
                    val === null || val === undefined ? (
                        '-'
                    ) : (
                        <Box
                            style={{
                                display: 'inline-block',
                                padding: '4px 12px',
                                borderRadius: 8,
                                background: bg,
                                color: fg,
                                fontSize: 13,
                                fontWeight: 700,
                            }}
                        >
                            {`₹${val}`}
                        </Box>
                    );
                break;
            }
            case 'decay': {
                const days = getEffectiveDecayDays(row);
                const isHigh = typeof days === 'number' && days >= 5;
                const bg = isHigh
                    ? 'rgba(244, 67, 54, 0.16)'
                    : 'rgba(255, 193, 7, 0.16)';
                const fg = isHigh ? '#f44336' : '#cc8a00';
                const bd = getDecayBreakdown(row);
                const fmt = (v: any) => (v === null || v === undefined ? '—' : `${v}d`);
                compValue =
                    days === null ? (
                        '-'
                    ) : (
                        <Tooltip
                            title={
                                <Box style={{ fontSize: 11, lineHeight: 1.5 }}>
                                    <div>LOD: {fmt(bd.LOD)}</div>
                                    <div>Staff/Client: {fmt(bd.StaffClient)}</div>
                                    <div>HOA: {fmt(bd.HOA)}</div>
                                </Box>
                            }
                        >
                            <Box
                                style={{
                                    display: 'inline-block',
                                    padding: '4px 12px',
                                    borderRadius: 8,
                                    background: bg,
                                    color: fg,
                                    fontSize: 13,
                                    fontWeight: 700,
                                    cursor: 'help',
                                }}
                            >
                                {`${days}d`}
                            </Box>
                        </Tooltip>
                    );
                break;
            }
            case 'iotStatus':
            case 'energyStatus': {
                const isIot = column?.mappingKey === 'iotStatus';
                const cmd = isIot
                    ? row?.iotCommandMobilityStatus
                    : row?.energyCommandMobilityStatus;
                const veh = isIot
                    ? row?.iotVehicleMobilityStatus
                    : row?.energyVehicleMobilityStatus;
                const statusBox = (val: any, tip: string) => {
                    const isNull = val === null || val === undefined;
                    const blocked = val === false;
                    const bg = isNull
                        ? 'rgba(120, 120, 120, 0.16)'
                        : blocked
                        ? 'rgba(244, 67, 54, 0.16)'
                        : 'rgba(76, 175, 80, 0.16)';
                    const fg = isNull ? '#6b7280' : blocked ? '#f44336' : '#2e7d32';
                    const text = isNull ? '--' : blocked ? 'B' : 'UB';
                    return (
                        <Tooltip title={tip}>
                            <Box
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minWidth: 32,
                                    padding: '4px 8px',
                                    borderRadius: 8,
                                    background: bg,
                                    color: fg,
                                    fontSize: 12,
                                    fontWeight: 700,
                                    cursor: 'help',
                                }}
                            >
                                {text}
                            </Box>
                        </Tooltip>
                    );
                };
                const partnerName = isIot
                    ? row?.iotPartnerName
                    : row?.energyPartnerName;
                const partnerConfigured = !!partnerName && partnerName !== '-';
                const partnerBlocked = cmd === false;
                compValue = (
                    <Box display="flex" alignItems="center" style={{ gap: 6 }}>
                        {statusBox(cmd, 'Command')}
                        {statusBox(veh, 'Vehicle')}
                        {partnerConfigured && (
                            <Button
                                variant="outlined"
                                onClick={(e: any) => {
                                    e?.stopPropagation();
                                    onBlockUnblock?.(
                                        row,
                                        partnerBlocked ? 'unblock' : 'block',
                                        isIot ? 'iot' : 'energy',
                                    );
                                }}
                                style={{
                                    minWidth: 0,
                                    borderRadius: 6,
                                    fontWeight: 600,
                                    fontSize: 11,
                                    textTransform: 'none',
                                    padding: '2px 8px',
                                    borderColor: partnerBlocked
                                        ? '#4caf50'
                                        : '#f44336',
                                    color: partnerBlocked ? '#4caf50' : '#f44336',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {partnerBlocked ? 'Unblock' : 'Block'}
                            </Button>
                        )}
                    </Box>
                );
                break;
            }
            case 'rowActions': {
                compValue = (
                    <Box
                        display={'flex'}
                        flexDirection={'row'}
                        alignItems={'center'}
                        style={{ gap: 8 }}
                    >
                        <Button
                            variant="outlined"
                            onClick={(e: any) => {
                                e?.stopPropagation();
                                onSendLocation?.(row);
                            }}
                            style={{
                                borderRadius: 6,
                                fontWeight: 600,
                                fontSize: 12,
                                textTransform: 'none',
                                padding: '4px 10px',
                                borderColor: '#EBEDF8',
                                color: '#14112D',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            📍 Send Location
                        </Button>
                        <Button
                            onClick={(e: any) => {
                                e?.stopPropagation();
                                handleSingleEVPage(row, 0);
                            }}
                            style={{
                                fontWeight: 600,
                                fontSize: 12,
                                textTransform: 'none',
                                padding: '4px 8px',
                                color: '#43419e',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            👁 View
                        </Button>
                    </Box>
                );
                break;
            }
            default:
                break;
        }
        return compValue;
    };
    // Notification Function
    const sendNotification = (message: string) => {
        if (Notification.permission === 'granted') {
            new Notification(message);
        }
    };
    const handleRowClick = (e: any, val: any, index: number) => {
        handleSingleEVPage(val, 0);
    };
    const handleConfirmYes = (data: any) => {
        setConfirmData(null);
        setConfirmModalOpen(false);
        if (data?.controlType === 'energy') {
            onPressEnergyControl(data);
        } else {
            onPressMobilize(data);
        }
    };
    const handleConfirmNo = () => {
        setConfirmData(null);
        setConfirmModalOpen(false);
    };
    const handleSingleEVPage = (ev: any, tab: number) => {
        let temp = {
            filteredValues: {
                ...JSON.parse(JSON.stringify(filtered)),
            },
            pagination: {
                ...JSON.parse(JSON.stringify(pagination)),
            },
            evListingPayload: {
                ...JSON.parse(JSON.stringify(evListingPayload)),
            },
            activeFilterCard: activeFilterCard,
        };
        history?.push(`/ev-sp/details/${ev?.evNumber}`, {
            payload: ev,
            selectedTab: tab,
            selectedFilter: temp,
        });
    };
    return {
        getCardFilterView,
        StyledTableCell,
        StyledTableHeadCell,
        StyledTableRow,
        getColumnComponentValue,
        handleRowClick,
        handleConfirmYes,
        handleConfirmNo,
    };
};
export default useEVTable;
